import { useParams } from "react-router-dom";
import RichTextEditor from "../components/RichTextEditor";
import { fetchArticleByDocumentId, updateArticle } from "../services/ArticleService";
import React, { useEffect, useState } from "react";

export default function ArticleDetails() {
  const { documentId } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!documentId) {
      console.error("No article ID provided!");
      setError("No article ID provided");
      setLoading(false);
      return;
    }

    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchArticleByDocumentId(documentId);
        console.log("Fetched article:", data);

        if (data) {
          setArticle({
            documentId: data.documentId,
            title: data.title || "",
            content: data.content || "<p></p>",
          });
        } else {
          console.warn("No article returned from API");
          setArticle({ documentId, title: "", content: "<p></p>" });
        }
      } catch (err) {
        console.error("Error fetching article:", err);
        setError("Failed to load article.");
        setArticle({ documentId: documentId, title: "", content: "<p></p>" });
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [documentId]);

  const handleSave = async () => {
    if (!article) return;
    setSaving(true);

    try {
      const updated = await updateArticle(article.id, {
        title: article.title,
        content: article.content,
      });

      if (updated) {
        alert("✅ Article saved successfully!");
        setArticle({
          id: updated.id,
          title: updated.attributes?.title || "",
          content: updated.attributes?.content || "<p></p>",
        });
      } else {
        alert("❌ Failed to save article");
      }
    } catch (err) {
      console.error("Error saving article:", err);
      alert("❌ Error occurred while saving");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading article...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        padding: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Editor on the left */}
      <div style={{ flex: 1 }}>
        <input
          className="title-input"
          value={article.title}
          onChange={(e) => setArticle({ ...article, title: e.target.value })}
          style={{ width: "100%", padding: "8px", fontSize: "18px", marginBottom: "10px" }}
        />

        <RichTextEditor
          value={article.content}
          onChange={(html) => setArticle({ ...article, content: html })}
        />

        <button
          style={{
            marginTop: "10px",
            padding: "8px 12px",
            borderRadius: "6px",
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>

      {/* Mobile-style live preview on the right */}
      <div
        style={{
          width: "375px", // mobile width
          height: "667px", // mobile height
          border: "1px solid #ccc",
          borderRadius: "20px",
          padding: "10px",
          overflowY: "auto",
          boxShadow: "0 0 10px rgba(0,0,0,0.15)",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <h5 style={{ textAlign: "center", margin: "0" }}>Live Preview (Mobile)</h5>
        <div
          style={{ flex: 1 }}
          dangerouslySetInnerHTML={{ __html: `${article.content}` }}
        />
      </div>
    </div>
  );
}
